import { types, getParent, IAnyModelType, Instance } from 'mobx-state-tree';

const OrganizationModel = types
  .model('Organization', {
    id: types.identifierNumber,
    name: types.string,
    email: types.string,
    apiKey: types.string,
    parentOrganization: types.maybeNull(types.late(() : IAnyModelType => OrganizationModel)),
    // childOrganizations: types.maybeNull(types.optional(types.array(types.late(() : IAnyModelType => OrganizationModel)), [])),
    childOrganizations: types.optional(types.array(types.late(() : IAnyModelType => OrganizationModel)), []),
  })
  .views(self => {
    return {
      get children() {
        // const childOrgs = self.childOrganizations as unknown as Array<Instance<typeof OrganizationModel>>;
        // const childOrgs = self !== null ? self.childOrganizations as unknown as Array<Instance<typeof OrganizationModel>>;
        if(self)
          return self.childOrganizations as Array<Instance<typeof OrganizationModel>>;

        return [];
      },
      get parent() {
        if (self.parentOrganization !== null)
          return self.parentOrganization as Instance<typeof OrganizationModel>;

        try {
          return getParent<Instance<typeof OrganizationModel>>(self, 2);
        } catch {
          return null;
        }
      },
      get parentId() {
        if (this.parent == null)
          return null;

        return this.parent.id;
      },
      hasChild(childId : number) : boolean {
        let hasChild = this.children.filter(child => child.id === childId).length > 0;
        if (hasChild)
          return true;

        hasChild = this.children.filter(child => child.hasChild(childId)).length > 0;
        return hasChild;
      }
    };
  }); 


//TODO: refactor organizationStore to use this instead of organizations from store. not being used right now
  const OrganizationsModel = types
    .model('Organizations', {
      orgs: types.array(OrganizationModel)
    })
    .views(self => {
      return {
        get allOrgs() {
          return self.orgs;
        }
      }
    })
    .actions(self => {
      return {
        addOrganizationToOrganizations(id : number, name : string, email : string, apiKey : string, childOrganizations?: IOrganizationModel[]) {
          self.orgs.push(OrganizationModel.create({
            id: id, 
            name: name, 
            email: email, 
            apiKey: apiKey,
            childOrganizations: childOrganizations
          }))
        }
      }
    })

export default OrganizationModel;
export type IOrganizationModel = typeof OrganizationModel.Type;
export type IOrganizationsModel = typeof OrganizationsModel.Type;